import PerformanceComparator from './container';

export default PerformanceComparator;
